import { createReducer, createSlice, combineReducers } from "@reduxjs/toolkit";
import { createAction } from 'redux-actions';

export const setVideoRoom = createAction("SET_VIDEO_ROOM");
import reduceReducers from 'reduce-reducers';
import videoPlayerReducer from 'src/shared/video/video_room/player/actions.jsx'
import dbReducer from 'src/shared/database_actions.jsx'

const reducer = createReducer({}, {
    // ["CABLE_VIDEO_ROOM_UPDATED"]: (state, action) => {
    //   if(action.payload.id == state.videoRoom.id)
    //     state.videoRoom = action.payload
    // },
    // [setVideoRoom]: (state, action) => {
    //   console.warn("setVideoRoom")
    //   state.videoRoom = action.payload
    // },
});

export default reduceReducers({}, reducer, dbReducer, videoPlayerReducer);
